  window.algoliaData = [
    {
      "objectID": "8173158334521",
      "id": "8173158334521",
      "title": "Palermo Vintage Women's (Copy)",
      "handle": "palermo-vintage-womens-copy",
      "vendor": "Puma",
      "brand": "Puma",
      "price": 150.00,
      "image_url": "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_748400_a.webp?v=1770626446",
      "images": [
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_748400_a.webp?v=1770626446",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_748400_b.webp?v=1770626446",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_762360_c.webp?v=1770626461",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_748400_c.webp?v=1770626461",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_762360_d.webp?v=1770626461",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_748400_d.webp?v=1770626461"
      ],
      "inStock": true,
      "sizes": ["5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5"],
      "productType": "Footwear",
      "description": "Bring some old school style to your step with these women's Palermo Vintage sneakers from PUMA. In a Cool Weather and Frosted Ivory colourway, these sneaks are cut from light and breathable mesh with smooth leather overlays. They feature a lace fastening to lock you in, with a mesh lining for a snug fit. Underfoot, they sit on a rubber midsole and outsole and are finished up with signature PUMA branding with a suede Formstrip.",
      "inventoryQuantity": 8,
      "inventory_policy": "deny",
      "publishedAt": "2026-02-09T21:40:01+13:00",
      "status": "active"
    },
    {
      "objectID": "8173059670073",
      "id": "8173059670073",
      "title": "Panache Patent Junior",
      "handle": "panache-patent-junior-819676213",
      "vendor": "Fila",
      "brand": "Fila",
      "price": 80.00,
      "image_url": "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_a.jpg?v=1770809539",
      "images": [
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_a.jpg?v=1770809539",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_b.jpg?v=1770809541",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_c.jpg?v=1770809544",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_d.jpg?v=1770809547",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_e.jpg?v=1770809549",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_f.jpg?v=1770809552",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765681_spin.jpg?v=1770809555"
      ],
      "inStock": false,
      "sizes": ["4", "4.5", "5", "5.5", "6", "6.5", "7"],
      "productType": "Footwear",
      "description": "Add a fresh hit to your rotation with these juniors' Panache Patent trainers from Fila. In a Black colourway with a shiny, patent finish, these treads have a tough synthetic leather upper for lasting wear. They have a tonal lace fastening for a secure fit, and sit above a thick foam midsole for a bold look. With light cushioning and a tough rubber tread, they're finished with signature Fila branding.",
      "inventoryQuantity": 0,
      "inventory_policy": "deny",
      "publishedAt": "2026-02-09T15:35:45+13:00",
      "status": "active"
    },
    {
      "objectID": "8173059637305",
      "id": "8173059637305",
      "title": "Sandblast Junior",
      "handle": "sandblast-junior-819676206",
      "vendor": "Fila",
      "brand": "Fila",
      "price": 90.00,
      "image_url": "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_a.jpg?v=1770809519",
      "images": [
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_a.jpg?v=1770809519",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_b.jpg?v=1770809522",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_c.jpg?v=1770809525",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_d.jpg?v=1770809528",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_e.jpg?v=1770809531",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_f.jpg?v=1770809534",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765683_spin.jpg?v=1770809537"
      ],
      "inStock": false,
      "sizes": ["4", "4.5", "5", "5.5", "6", "6.5", "7"],
      "productType": "Footwear",
      "description": "Make a statement when you step out in these juniors' Sandblast trainers from Fila. In a neutral Gardenia colourway, these JD-exclusive kicks have a smooth, durable synthetic leather upper. With laces to lock you in, they sit above a thick, chunky platform sole for a bold look. A grippy rubber outsole delivers everyday traction. Signed off with iconic Fila branding throughout.",
      "inventoryQuantity": 0,
      "inventory_policy": "deny",
      "publishedAt": "2026-02-09T15:35:44+13:00",
      "status": "active"
    },
    {
      "objectID": "8173059604537",
      "id": "8173059604537",
      "title": "Sandblast Junior",
      "handle": "sandblast-junior-819676200",
      "vendor": "Fila",
      "brand": "Fila",
      "price": 90.00,
      "image_url": "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_a.jpg?v=1770809501",
      "images": [
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_a.jpg?v=1770809501",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_b.jpg?v=1770809503",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_c.jpg?v=1770809506",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_d.jpg?v=1770809509",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_e.jpg?v=1770809511",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_f.jpg?v=1770809514",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765682_spin.jpg?v=1770809517"
      ],
      "inStock": false,
      "sizes": ["4", "4.5", "5", "5.5", "6", "6.5", "7"],
      "productType": "Footwear",
      "description": "Go bold in these juniors' Fila Sandblast trainers. In a White colourway, these JD-exclusive sneaks have a thick, chunky platform bringing all the main character energy. They have a smooth synthetic leather upper, with a tonal lace fastening to lock you in. With light cushioning underfoot and a grippy rubber tread, they're signed off with iconic Fila branding throughout.",
      "inventoryQuantity": 0,
      "inventory_policy": "deny",
      "publishedAt": "2026-02-09T15:35:42+13:00",
      "status": "active"
    },
    {
      "objectID": "8173059571769",
      "id": "8173059571769",
      "title": "Palermo Vintage Women's",
      "handle": "palermo-vintage-womens-819676121",
      "vendor": "Puma",
      "brand": "Puma",
      "price": 150.00,
      "image_url": "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_a.jpg?v=1770809481",
      "images": [
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_a.jpg?v=1770809481",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_b.jpg?v=1770809485",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_c.jpg?v=1770809488",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_d.jpg?v=1770809491",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_e.jpg?v=1770809493",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_f.jpg?v=1770809496",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_754222_spin.jpg?v=1770809498"
      ],
      "inStock": false,
      "sizes": ["5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5"],
      "productType": "Footwear",
      "description": "Bring some old school style to your step with these women's Palermo Vintage sneakers from PUMA. In a Cool Weather and Frosted Ivory colourway, these sneaks are cut from light and breathable mesh with smooth leather overlays. They feature a lace fastening to lock you in, with a mesh lining for a snug fit. Underfoot, they sit on a rubber midsole and outsole and are finished up with signature PUMA branding with a suede Formstrip.",
      "inventoryQuantity": 0,
      "inventory_policy": "deny",
      "publishedAt": "2026-02-09T15:35:41+13:00",
      "status": "active"
    },
    {
      "objectID": "8173059702841",
      "id": "8173059702841",
      "title": "Corda Suede Junior",
      "handle": "corda-suede-junior-819676282",
      "vendor": "Fila",
      "brand": "Fila",
      "price": 110.00,
      "image_url": "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765823_a.jpg?v=1770684335",
      "images": [
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765823_a.jpg?v=1770684335",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765823_b.jpg?v=1770684337",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765823_c.jpg?v=1770684339",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765823_d.jpg?v=1770684342",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765823_e.jpg?v=1770684344",
        "https://cdn.shopify.com/s/files/1/0766/9121/0297/files/jd_765823_f.jpg?v=1770684346"
      ],
      "inStock": false,
      "sizes": ["4", "4.5", "5", "5.5", "6", "6.5", "7"],
      "productType": "Footwear",
      "description": "Exclusive to JD. Freshen up your rotation with these juniors' Corda Suede trainers from Fila. In a Black colourway, they have a suede and synthetic upper for lasting wear. They have a tonal lace fastening to lock you in, and sit above a chunky foam midsole. With a grippy gum rubber outsole for traction, they're finished with signature Fila branding.",
      "inventoryQuantity": 0,
      "inventory_policy": "deny",
      "publishedAt": "2026-02-09T15:35:46+13:00",
      "status": "active"
    }
  ];
